define([
	"dojo/_base/declare",
	"csi/action/ProxyController"
], function(declare,ProxyController) {

	return declare(ProxyController, {
		process: function() {
			// summary: end action on original controller
			this.disableActionView(true);

			var	acOrig = this.getOriginalController();
			acOrig.m_proxy = this;
			acOrig.resumeProcess();
			acOrig.postProcess();
		}
	});
});